import dot from 'dot-object';
import deepEqual from 'fast-deep-equal';

const DEEP_EQUAL_KEYS = new Set([
  'questionnaire.options',
  'questionnaire.answers',
]);

const isEqualByKey = (key, oldValue, newValue) => {
  if (DEEP_EQUAL_KEYS.has(key)) {
    return deepEqual(oldValue, newValue);
  }

  return oldValue === newValue;
};

export const dotMerge = (data, target) => {
  let changed = false;

  Object.entries(data).forEach(([key, value]) => {
    const oldValue = dot.pick(key, target);

    if (!isEqualByKey(key, oldValue, value)) {
      changed = true;
      dot.set(key, value, target, false);
    };
  });

  return changed;
};